import { useId } from '@react-aria/utils';
import { ReactElement } from 'react';

import {
	Banner,
	Body,
	Button,
	ButtonContainer,
	Content,
	ExitIcon,
	ExitIconWrapper,
	Header,
	Message,
} from './styles';
import { BottomBannerProps } from './types';

const BottomBanner = ({
	onAccept,
	onDecline,
	onDismiss,
	isOpen,
	title,
	children,
	className,
	acceptText,
	declineText,
	innerRef,
	id,
}: BottomBannerProps): ReactElement | null => {
	const titleId = useId();
	const descriptionId = useId();

	return isOpen ? (
		<Banner
			id={id}
			ref={innerRef}
			aria-labelledby={titleId}
			aria-describedby={descriptionId}
			tabIndex={0}
			className={className}
		>
			<Content>
				<Message>
					{title && <Header id={titleId}>{title}</Header>}
					<Body id={descriptionId}>{children}</Body>
				</Message>
				<ButtonContainer>
					<Button fullWidth backgroundColor="blue3" onPress={onAccept}>
						{acceptText}
					</Button>
					{onDecline && declineText && (
						<Button
							fullWidth
							borderColor="blue3"
							textColor="blue3"
							backgroundColor="white"
							onPress={onDecline}
						>
							{declineText}
						</Button>
					)}
				</ButtonContainer>
				{onDismiss && (
					<ExitIconWrapper>
						<ExitIcon onPress={onDismiss} $isDark={false} aria-label="exit" />
					</ExitIconWrapper>
				)}
			</Content>
		</Banner>
	) : null;
};

export default BottomBanner;
